import { CodeBlock } from '@basehub/tiptap-api-utils'
import { ReactNodeViewRenderer } from '@tiptap/react'
import { CodeBlockWrapper } from './node-view-wrapper'
import { createLowlight, common } from 'lowlight'

const lowlight = createLowlight(common)

export const CodeBlockWithLanguage = CodeBlock.extend({
  addNodeView() {
    return ReactNodeViewRenderer(CodeBlockWrapper)
  },
  addKeyboardShortcuts() {
    return {
      'Shift-Ctrl-\\': () => this.editor.commands.toggleCodeBlock(),
      ArrowDown: ({ editor }) => {
        const { selection } = editor.state
        const { $from } = selection
        const { parent } = $from

        // if is in the last line of the code block and the code block is the last block
        if (
          parent.type.name === 'codeBlock' && // is in a code block
          parent.nodeSize - 2 === $from.parentOffset && // is in the last line
          !editor.state.doc.nodeAt(selection.from + 1)
        ) {
          return editor.commands.exitCode()
        }
        return false
      },
      ArrowUp: ({ editor }) => {
        const { selection } = editor.state
        const { $from } = selection
        const { parent } = $from

        // if is in the first line of the code block and the code block is the first block
        if (
          parent.type.name === 'codeBlock' && // is in a code block
          $from.parentOffset === 0 && // is in the first line
          selection.from === 1
        ) {
          return editor
            .chain()
            .insertContentAt(selection.from - 1, [
              {
                type: 'paragraph',
                content: [],
              },
            ])
            .focus()
            .run()
        }
        return false
      },
    }
  },
}).configure({ lowlight, defaultLanguage: 'text', exitOnTripleEnter: true })
// TipTap has a exitOnArrowDown option that is not working as we expect
// so we handle it manually
